var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xxl-12"},[_c('DomainsTable',{attrs:{"list":_vm.list,"count":_vm.count,"status":_vm.status,"title":`<span class='card-label font-weight-bolder text-dark'> Domains</span>
            <span class='text-muted mt-3 font-weight-bold font-size-sm'>
                Total count: ${_vm.count}
            </span>`}},[_c('domains-filter')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }